import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { Phone, Menu, X, PaintBucket } from 'lucide-react';

const PaintingHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Service Areas', href: '/service-areas' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-[#1E3A8A] rounded-lg flex items-center justify-center">
              <PaintBucket className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-[#0F172A] tracking-tight">
                D'este Painting
              </h1>
              <p className="text-xs text-[#64748B]">Hollywood, FL</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.href)
                    ? 'bg-[#1E3A8A] text-white'
                    : 'text-[#0F172A] hover:bg-[#F1F5F9]'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="tel:+19548172046" className="flex items-center text-[#1E3A8A] font-semibold hover:text-[#EA580C] transition-colors">
              <Phone className="w-5 h-5 mr-2" />
              <span>(954) 817-2046</span>
            </a>
            <Link to="/contact">
              <Button className="bg-[#EA580C] hover:bg-[#C2410C] text-white">
                Free Quote
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block px-4 py-3 rounded-lg text-base font-medium ${
                  isActive(item.href)
                    ? 'bg-[#1E3A8A] text-white'
                    : 'text-[#0F172A] hover:bg-[#F1F5F9]'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 space-y-2">
              <a
                href="tel:+19548172046"
                className="block w-full text-center py-3 bg-[#1E3A8A] text-white rounded-lg font-semibold"
              >
                <Phone className="w-5 h-5 inline mr-2" />
                (954) 817-2046
              </a>
              <Link
                to="/contact"
                className="block w-full text-center py-3 bg-[#EA580C] text-white rounded-lg font-semibold"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Free Quote
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default PaintingHeader;
